<template >
    
    <div >
        <LoginNavbar :isAuthenticated="false" :company="company" :lang="lang"/>
    <div>
        <div>
       
            <router-link to="/login" class="back" :class="{'rtl': lang==1, 'ltr': lang==2}">
                <i  style="font-size: 24px" :class="{'pylon-icon-ArrowRight': lang == 1, 'pylon-icon-Arrow-Left': lang==2}"></i>
                
                {{ $t("back_to_login")}}
               
            </router-link>  
            <p class="faq-header" :class="{'rtl': lang==1, 'ltr': lang==2}">{{$t("faq_header")}}</p>
             
        </div>
          <FaqChild :lang='lang' :company='company'/>   
    </div>
    <Footer :isAuthenticated="apply" :company="company" :lang="lang"/>

    </div>
</template>
  
<script>
import Footer from '@/components/Footer.vue';
import LoginNavbar from '@/components/Login/LoginNavbar.vue';
import FaqChild from "@/components/FAQ/FaqChild.vue";
  export default {
    components: {
    Footer,
    LoginNavbar,
    FaqChild
  },

    props: ["lang", "company"],
    
    data() {
      return {
        apply: true,
      }
    },
   watch:{
   },
    methods: {
    
    
    }, 
  };
  </script>
  
  <style scoped>
  .back{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  font-weight: 600 !important;
  font-size: 14px;
  line-height: 20px;
  text-decoration: none;
  color: #767676;
  max-width: 856px;
  margin:0px auto;
  margin-top:32px !important;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  /* margin-bottom: 8px; */
}
  .faq-header{
    font-weight: 700 !important;
    font-size: 32px;
    line-height: 39px;
    color: #002369;
    margin-top: 48px;
    max-width: 856px;
    margin: 0px auto;
    margin-top: 5px;
    padding: 0px;
    margin-bottom: 44px;
  }

  
  @media(max-width:600px){
    .faq-header{
    font-size: 24px;
  }
  }

  </style>